module.exports = __webpack_public_path__ + "static/img/italogo.d49e7804.png";